export default __webpack_public_path__ + "static/media/tobacco.666e7c0c.png";